module.exports = __webpack_public_path__ + "static/media/entregasubsidiocierre.e498cd46.webp";